/**
 * PRF File Uploader client.
 *
 * Thin wrapper around the Benchmetrics file-upload microservice. We only use
 * it from the admin dashboard (org logo upload today). The api key is shipped
 * to the browser intentionally — the service is architected for direct
 * browser use, same way Cloudinary unsigned uploads work. If we ever need
 * server-side signing, proxy through a Worker endpoint instead.
 *
 * See file_uploader_service_doc.md in the repo root for the underlying contract.
 */

const BASE_URL = 'https://file-uploader.benchmetrics.workers.dev';
const API_KEY = 'benchmetrics-3dc3c222-64ab-4d44-abd5-84f648e1d8af';

export type UploadedFile = { url: string; id: string };

export async function uploadFile(file: File): Promise<UploadedFile> {
  const fd = new FormData();
  fd.append('files', file);

  const res = await fetch(`${BASE_URL}/upload`, {
    method: 'POST',
    body: fd,
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok) {
    throw new Error(`upload_failed_${res.status}`);
  }

  const data = (await res.json()) as Array<{
    imageUrl?: string;
    imageId?: string;
    fileUrl?: string;
    fileId?: string;
  }>;
  const first = data[0];
  if (!first) throw new Error('upload_empty_response');

  const url = first.imageUrl ?? first.fileUrl;
  const id = first.imageId ?? first.fileId;
  if (!url || !id) throw new Error('upload_missing_fields');
  return { url, id };
}

export async function deleteFile(id: string): Promise<void> {
  const res = await fetch(`${BASE_URL}/delete/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { 'x-api-key': API_KEY },
  });
  if (!res.ok && res.status !== 404) {
    throw new Error(`delete_failed_${res.status}`);
  }
}
